// extracted by mini-css-extract-plugin
export default {"bodyCollaps":"Body_bodyCollaps__789rm","bodyexpend":"Body_bodyexpend__MUAus"};